import { z } from 'zod'
import { paginatedStateSchema } from '../base'

// -------------------------
// Gallery State Validation
// -------------------------
export const galleryStateItemSchema = z.object({
  id: z.string(),
  title: z.string(),
  description: z.string().nullable(),
  url: z.string(),
  thumbnailUrl: z.string()
})

export const galleryStateSchema = z.object({
  ...paginatedStateSchema.shape,
  items: z.array(galleryStateItemSchema),
  selectedItem: galleryStateItemSchema.nullable()
})

export const galleryActionValidation = {
  'gallery/setGallery': z.array(galleryStateItemSchema),
  'gallery/updateGalleryItem': galleryStateItemSchema,
  'gallery/setSelectedItem': galleryStateItemSchema.nullable(),
  'gallery/setPagination': z.object({
    page: z.number(),
    limit: z.number(),
    total: z.number()
  })
} as const

// Type inference helpers
export type GalleryStateValidation = z.infer<typeof galleryStateSchema>
